import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {from, Observable} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {AuthService} from '../service/auth.service';
import {TenantService} from '../service/tenant.service';
import {DEFAULT_LOCALE} from '../model/Locale';
import {Role} from '../model/auth/Role';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService,
              private tenantService: TenantService,
              @Inject(LOCALE_ID) private locale: string) {
  }

  private static isBucketUrl(request: HttpRequest<any>): boolean {
    return request.url.search('s3.*amazonaws.com') !== -1;
  }

  private static isOpenUrl(request: HttpRequest<any>): boolean {
    return request.url.endsWith('/hosts/contact')
      || (request.url.search('users/search.*') !== -1 && !request.url.endsWith('/auth'));
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (BasicAuthInterceptor.isBucketUrl(request)) {
      return next.handle(request);
    }

    return from(this.authService.getSession())
      .pipe(switchMap(session => {
        const tenant = this.tenantService.getTenant();

        const tenantHeaders = {
          'x-api-locale': this.locale || DEFAULT_LOCALE,
          'x-tenant-domain': tenant && tenant.domain ? tenant.domain : ''
        };

        if (BasicAuthInterceptor.isOpenUrl(request)) {
          request = request.clone({
            setHeaders: {
              ...tenantHeaders
            }
          });
        } else if (session && session.isValid()) {
          request = request.clone({
            setHeaders: {
              Authorization: session.token || '',
              'x-api-role': session.role && session.role != Role.Participant ? session.role as string : '',
              ...tenantHeaders
            }
          });
        }

        return next.handle(request);
      }));
  }
}
